export default "__VITE_ASSET__BjT$AaND__"